import PortalIdParser from 'PortalIdParser';
import { View } from 'foundations-components/components/View';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { Button } from 'foundations-components/transitional/components/Button';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ExportDialogNotificationsOfModal = ({
  onClose
}) => /*#__PURE__*/_jsxs(View, {
  as: "div",
  children: [/*#__PURE__*/_jsxs(DialogBody, {
    children: [/*#__PURE__*/_jsx(Text, {
      as: "h2",
      marginBlockEnd: "400",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "exportDialog.preference.notificationsOffHeading"
      })
    }), /*#__PURE__*/_jsx(FormattedMessage, {
      message: "exportDialog.preference.notificationsOffText"
    })]
  }), /*#__PURE__*/_jsxs(DialogFooter, {
    borderRadius: "transitional-full-0",
    children: [/*#__PURE__*/_jsx(Button, {
      use: "primary",
      href: `/user-preferences/${PortalIdParser.get()}/global-preferences`,
      external: true,
      onClick: onClose,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "exportDialog.preference.notificationCta"
      })
    }), /*#__PURE__*/_jsx(Button, {
      onClick: onClose,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "exportDialog.cancel"
      })
    })]
  })]
});